import api from '@/api/axios/main.api'

export const fetchLogAll = (params) => {
  return api.get(`/api/activity-log/search`, { params })
}

export const fetchLogUser= (data, params) => {
  return api.get(`/api/activity-log/user/${data.username}`, { params })
}
